
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M72.05 90.31h-.25V24a11.7 11.7 0 00-23.39 0v66.39c-7.6 4.27-12.86 13.32-12.86 22.66a24.95 24.95 0 1049.89 0c-.05-9.3-5.84-18.45-13.39-22.74z"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"60.44","cy":"111.94","r":"14.25"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M60.11 29.98v66.03M72.04 33.88h11.04M80.52 43.62h-8.45M72.04 52.88h11.04M72.04 72.37h11.04M80.52 62.63h-8.45"}}),_c('path',{attrs:{"d":"M97.81 34.12c0-6.8 4-10.95 9.36-10.95a7.84 7.84 0 015.8 2.6l-1.47 1.75a5.71 5.71 0 00-4.28-2c-4 0-6.64 3.26-6.64 8.52s2.53 8.63 6.53 8.63a6.32 6.32 0 004.89-2.36l1.48 1.69a8.15 8.15 0 01-6.48 3c-5.25 0-9.19-4-9.19-10.88z","fill":"#fff"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"91.15","cy":"15.11","r":"3.11"}})])
          )
        }
      }
    